<template>
  <van-field
    v-model="val"
    :label="label"
    :placeholder="placeholder || label"
    :rows="rows" :maxlength="maxlength"
    :autosize="autosize" :show-word-limit="showWordLimit"
    :required="required"
    :rules="rules"
    :readonly="readonly"
    :clearable="clearable"
    :disabled="disabled"
    type="textarea"
    @input="change"
  />
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    rules: {
      type: Array,
      default: function() {
        return [{ required: this.required, message: '请输入' + this.label }]
      }
    },
    maxlength: {
      type: Number,
      default: 100
    },
    autosize: {
      type: Boolean,
      default: true
    },
    showWordLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTextarea.vue